import { TextButton } from '@zillow/constellation-10';
import { FunctionComponentWithChildren } from 'src/utils/types';
import { PhoneLinkProps } from './types';
/* eslint-disable local-rules/require-storybook-documentation */
/**
 * @stories {@link file://./../../../stories/Atomic/Typography/PhoneLink.stories.tsx}
 */
export const PhoneLink: FunctionComponentWithChildren<PhoneLinkProps> = ({
    children,
    formatted,
    asLink,
    onClick,
    ...rest
}) => (
    <TextButton
        {...rest}
        css={{
            paddingTop: 'sm',
        }}
        role="link"
        onClick={() => {
            if (onClick) {
                onClick();
            }
            if (!window.Cypress) {
                window.open(asLink, '_self');
            }
        }}>
        {children ?? formatted}
    </TextButton>
);
